import { useRevealOnScroll } from "@/hooks/use-reveal-on-scroll";
import { AGAVE_PINAS } from "@/lib/sps-content";

export const Statement = () => {
  useRevealOnScroll();
  return (
    <section
      id="marcas"
      data-testid="statement-section"
      className="relative bg-white overflow-hidden"
    >
      <div className="relative w-full min-h-screen">
        {/* Background image — full section */}
        <img
          src={AGAVE_PINAS}
          alt="Piñas de agave"
          className="absolute inset-0 w-full h-full object-cover object-center select-none pointer-events-none"
        />

        {/* Overlaid heading at the top */}
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-24 pt-32 md:pt-40 lg:pt-48 pb-12 w-full text-center">
          <h2
            data-testid="statement-title"
            className="reveal font-sans-modern font-bold text-[#002438] leading-[1.15] tracking-tight uppercase text-[2.5rem] md:text-[3.25rem]"
          >
            Redefiniendo la excelencia
            <br />
            en derivados de Agave.
          </h2>
        </div>
      </div>
    </section>
  );
};
